/**
 * @flow
 * @providesModule Utils
 */

export function throttle(callback: any, wait: number, context: any = this) {
    let timeout = null;
    let callbackArgs = null;

    const later = () => {
        callback.apply(context, callbackArgs);
        timeout = null
    };

    return function(...args: any) {
        if (!timeout) {
            callbackArgs = args;
            timeout = setTimeout(later, wait);
        }
    }
}

export function escHandler(callback: () => void, interactionCallback?: () => void) {
    let interacted = false;
    const keyHandler = (ev: any) => {
        if (ev.keyCode == 27) {
            callback();
        } else if (interactionCallback && !interacted) {
            interacted = true;
            interactionCallback();
        }
    }
    document.addEventListener('keydown', keyHandler);
    return () => {
        document.removeEventListener('keydown', keyHandler);
    }
}

export const isMobileBrowser = /mobile|phone/i.test(window.navigator.userAgent);

export function readCookie(name: string) {
    return (name = new RegExp('(?:^|;\\s*)' + ('' + name).replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&') + '=([^;]*)').exec(document.cookie)) && name[1];
}



// WEBPACK FOOTER //
// ./src/lib/utils.js